function Planning_icon({ selected }: { selected: boolean }) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.07003 20.143C5.20334 20.1432 5.33579 20.1208 5.46207 20.0767L7.17211 19.5329C7.64694 19.4374 8.08213 19.1945 8.41921 18.8367L19.1935 7.72949C19.4686 7.45359 19.6279 7.07747 19.637 6.68167C19.6388 6.38001 19.5257 6.08944 19.3221 5.87273L17.8049 4.31437C17.5485 4.09027 17.2171 3.97866 16.8819 4.00338C16.5467 4.02825 16.2342 4.18737 16.0114 4.447L5.23706 15.5542C4.90114 15.9085 4.677 16.3592 4.5942 16.8474L4.06699 18.6113C3.99524 18.8165 3.98089 19.0384 4.02509 19.2516C4.06943 19.4649 4.17088 19.6612 4.31782 19.8181C4.51814 20.0231 4.78791 20.1396 5.07003 20.143ZM5.80932 17.1921C5.81219 17.1591 5.81219 17.1258 5.80932 17.0926C5.85022 16.8642 5.96056 16.6552 6.12429 16.4958L16.95 5.38175L17.0143 5.33527L18.3643 6.72784C18.351 6.75094 18.3336 6.77121 18.3129 6.7875L7.51292 17.9016C7.35838 18.0705 7.15576 18.1843 6.93435 18.2265H6.83792L5.37856 18.7238L5.80932 17.1921Z"
        fill={selected ? "#AA84A1" : "#53514D"}
      />
    </svg>
  );
}

export default Planning_icon;
